import { render, staticRenderFns } from "./InputChipString.vue?vue&type=template&id=0a4b4d2b&scoped=true&"
import script from "./InputChipString.ts?vue&type=script&lang=ts&"
export * from "./InputChipString.ts?vue&type=script&lang=ts&"
import style0 from "./InputChipString.scss?vue&type=style&index=0&id=0a4b4d2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4b4d2b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
